import { Link } from 'react-router-dom'

import * as api from 'api/api'
import { useAuth } from 'auth/AuthContext'
import { useRegion } from 'components/app-shell/context/RegionContext'
import { Icon } from 'components/Icon'
import { EmptyState, ErrorState, Spinner } from 'components/ui'
import { formatDate, roleLabel } from 'lib/format'
import { tx } from 'lib/i18n'
import { useAsync } from 'lib/hooks'

export const ProjectsPage = () => {
  const { user } = useAuth()
  const { locale } = useRegion()
  const { data: projects, error, loading, reload } = useAsync(api.fetchProjects, [])

  return (
    <div className="page">
      <div className="page__head">
        <div>
          <h1>{tx(locale, 'المشاريع', 'Projects')}</h1>
          <p className="muted">{tx(locale, 'اختر مشروعاً لعرض فهرس التقارير اليومية', 'Choose a project to open its daily reports')}</p>
        </div>
        {user?.isAdmin ? (
          <Link to="/projects/new" className="btn btn--primary">
            <Icon name="plus" />
            {tx(locale, 'مشروع جديد', 'New project')}
          </Link>
        ) : null}
      </div>

      {loading && !projects ? (
        <Spinner />
      ) : error ? (
        <ErrorState message={error} onRetry={reload} />
      ) : !projects?.length ? (
        user?.isAdmin ? (
          <EmptyState title={tx(locale, 'لا توجد مشاريع بعد', 'No projects yet')}>
            <Link to="/projects/new" className="btn btn--primary">
              <Icon name="plus" />
              {tx(locale, 'إنشاء أول مشروع', 'Create the first project')}
            </Link>
          </EmptyState>
        ) : (
          <EmptyState title={tx(locale, 'لا توجد مشاريع مرتبطة بحسابك', 'No projects are linked to your account')}>
            <p className="muted">{tx(locale, 'تواصل مع مدير النظام لإضافتك إلى مشروع.', 'Ask an admin to add you to a project.')}</p>
          </EmptyState>
        )
      ) : (
        <ul className="project-grid">
          {projects.map((project) => (
            <li key={project.id}>
              <Link to={`/projects/${project.id}`} className="project-card">
                <div className="project-card__top">
                  <span className="chip">{roleLabel(project.myRole, locale)}</span>
                  <Icon name={locale === 'en' ? 'chevronRight' : 'chevronLeft'} />
                </div>
                <h2>{project.name}</h2>
                <dl>
                  {project.tenderNumber ? (
                    <div>
                      <dt>{tx(locale, 'العطاء', 'Tender')}</dt>
                      <dd>{project.tenderNumber}</dd>
                    </div>
                  ) : null}
                  {project.client ? (
                    <div>
                      <dt>{tx(locale, 'صاحب العمل', 'Client')}</dt>
                      <dd>{project.client}</dd>
                    </div>
                  ) : null}
                  <div>
                    <dt>{tx(locale, 'المدة', 'Duration')}</dt>
                    <dd>
                      {formatDate(project.startDate)} – {formatDate(project.endDate)}
                    </dd>
                  </div>
                </dl>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
